import React from 'react';

import { Card } from 'components/card/Card';

import s from './PersonCard.scss';

interface IProps {
  image: React.ReactElement<any> | null;
  name: string;
  role?: string;
  roleDescription?: string;
  email?: string;
  tel?: string;
}

export const PersonCard = ({ image, name, role, roleDescription, email, tel }: IProps) => (
  <Card aspectRatio="square" heading={name} image={image}>
    {role && <div className={s.personCard__role}>{role}</div>}
    {roleDescription && <div className={s.personCard__roleDescription}>{roleDescription}</div>}
    {(email || tel) && (
      <address className={s.personCard__contact}>
        {email && <a href={`mailto:${email}`}>{email}</a>}
        {tel && <a href={`tel:${tel}`}>{tel}</a>}
      </address>
    )}
  </Card>
  );
